import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MaintenancePlans from './components/MaintenancePlans';
import Pricing from './components/Pricing';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => (
  <div className="min-h-screen font-sans">
    <Navbar />
    <Hero />
    <MaintenancePlans />
    <Pricing />
    <Benefits />
    <Testimonials />
    <Contact />
    <Footer />
  </div>
);

export default HomePage;
